export default {"src":"/_next/static/media/ra-speed.f540e111.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};